type RuntimeEnvironment = NonNullable<Window["__ENV__"]>;

const value = (key: keyof RuntimeEnvironment, buildTimeValue?: string): string =>
  window.__ENV__?.[key] || buildTimeValue || "";

export const runtimeEnv = {
  apiUrl: value("REACT_APP_API_URL", process.env.REACT_APP_API_URL),
  yMapsKey: value("REACT_APP_YMAP_KEY", process.env.REACT_APP_YMAP_KEY),
  wikiToken: value("REACT_APP_WIKI", process.env.REACT_APP_WIKI),
  cloudPaymentsPublicId: value(
    "REACT_APP_CLOUDPAYMENTS_PUBLIC_ID",
    process.env.REACT_APP_CLOUDPAYMENTS_PUBLIC_ID,
  ),
  firebase: {
    apiKey: value(
      "REACT_APP_FIREBASE_API_KEY",
      process.env.REACT_APP_FIREBASE_API_KEY,
    ),
    authDomain: value(
      "REACT_APP_FIREBASE_AUTH_DOMAIN",
      process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    ),
    projectId: value(
      "REACT_APP_FIREBASE_PROJECT_ID",
      process.env.REACT_APP_FIREBASE_PROJECT_ID,
    ),
    storageBucket: value(
      "REACT_APP_FIREBASE_STORAGE_BUCKET",
      process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    ),
    messagingSenderId: value(
      "REACT_APP_FIREBASE_MESSAGING_SENDER_ID",
      process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    ),
    appId: value(
      "REACT_APP_FIREBASE_APP_ID",
      process.env.REACT_APP_FIREBASE_APP_ID,
    ),
    measurementId: value(
      "REACT_APP_FIREBASE_MEASUREMENT_ID",
      process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
    ),
    vapidKey: value(
      "REACT_APP_FIREBASE_VAPID_KEY",
      process.env.REACT_APP_FIREBASE_VAPID_KEY,
    ),
  },
} as const;
